<template>
    <div style="text-align: center; margin: 150px;">
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>Sorry, the page you were looking for could not be found. Please check the URL and try again.</p>
    </div>
</template>

<style scoped src="@/assets/css/admin.css"></style>